'use client';

import styled, { css } from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';
import { NAVIGATION_OFFSET_CSS_VARIABLE } from '@telialt/utils/src/NavigationUtils/constants';

type WrapperProps = {
    $hasSectionSpacing?: boolean;
};

export const BlockWidgetWrapper = styled.div<WrapperProps>`
    scroll-margin-top: var(${NAVIGATION_OFFSET_CSS_VARIABLE});
    ${({ $hasSectionSpacing }) =>
        $hasSectionSpacing &&
        css`
            display: flex;
            flex-direction: column;
            gap: ${getPurpurSpacing('300')};
            padding-top: ${getPurpurSpacing('400')};
            padding-bottom: ${getPurpurSpacing('400')};

            ${purpurMedia('md')`
                gap: ${getPurpurSpacing('400')};
                padding-top: ${getPurpurSpacing('600')};
                padding-bottom: ${getPurpurSpacing('600')};
            `};
        `};
`;
